import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Button,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { MarkdownEditor } from "@ofqual/portal-components/components/MarkdownEditor";
import { Select } from "@ofqual/portal-components/components/Select";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FoiItem } from "../../../../domain/FoiItem";
import { authSelector } from "../../../../redux/selectors";
import {
  customerTypeService,
  directorateService,
  exceptionalCircumstanceService,
  learnerTypeService,
  peCategoryService,
  peService,
} from "../../../../services";
import { PeRequiredItem } from "../../../../services/PeService";
import { Error } from "../../../common/Error";
//import { assignCase, unassignCase } from "../../../../redux/actions";

type CreateDialogProps = {
  foiItem: FoiItem;
};
const useStyles = makeStyles((theme) => ({
  dialogActions: {
    padding: 15,
  },
}));

export const CreatePeDialog: React.FC<CreateDialogProps> = ({
  foiItem,
}) => {
  const classes = useStyles();
  const { token } = useSelector(authSelector);
  const { handleSubmit, control, errors } = useForm();
  const { push } = useHistory();

  const [
    categoryLookups,
    directorateLookups,
    customerTypeLookups,
    learnerTypeLookups,
    exceptionalCircumstanceLookup,
  ] = useLookup(
    peCategoryService,
    directorateService,
    customerTypeService,
    learnerTypeService,
    exceptionalCircumstanceService
  );

  const onSubmit = async (peRequiredItem: PeRequiredItem) => {
    const res = await peService.createPe(foiItem.id, peRequiredItem, {
      token,
    });
    if (res.status === 409) {
      console.log("Already used to create a PE");
    } else {
      push(`/public-enquiries/list/${res.data}`);
    }
  };

  return (
    <>
      <>
        <form>
          <DialogTitle data-test="assign-ctr-dialog-title">
            Transfer this FOI to a PE
            <Divider />
          </DialogTitle>

          <DialogContent>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="customerTypeId"
                  defaultValue={null}
                  rules={{ required: true }}
                  as={
                    <Select
                      label="Customer Type"
                      datatest="customer-type"
                      required
                    >
                      {customerTypeLookups}
                    </Select>
                  }
                />
                {errors.customerTypeId && (
                  <Error data-test="customerTypeId-error">
                    This field is required
                  </Error>
                )}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="directorate"
                  defaultValue={null}
                  rules={{ required: true }}
                  as={
                    <Select
                      label="Directorate"
                      datatest="directorate-field"
                      required
                    >
                      {directorateLookups}
                    </Select>
                  }
                />
                {errors.directorate && (
                  <Error data-test="directorate-error">
                    This field is required
                  </Error>
                )}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="category"
                  defaultValue={null}
                  rules={{ required: true }}
                  as={
                    <Select label="Category" datatest="category-field" required>
                      {categoryLookups}
                    </Select>
                  }
                />
                {errors.category && (
                  <Error data-test="category-error">
                    This field is required
                  </Error>
                )}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="learnerType"
                  defaultValue={null}
                  rules={{ required: true }}
                  as={
                    <Select
                      label="Learner type"
                      datatest="learner-type-field"
                      required
                    >
                      {learnerTypeLookups}
                    </Select>
                  }
                />
                {errors.learnerType && (
                  <Error data-test="learnerType-error">
                    This field is required
                  </Error>
                )}
              </Grid>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="exceptionalCircumstances"
                  defaultValue={null}
                  rules={{ required: true }}
                  as={
                    <Select
                      label="Exceptional circumstance"
                      datatest="exceptional-circumstances-field"
                      required
                    >
                      {exceptionalCircumstanceLookup}
                    </Select>
                  }
                />
                {errors.exceptionalCircumstances && (
                  <Error data-test="exceptional-circumstances-error">
                    This field is required
                  </Error>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <Controller
                  control={control}
                  rules={{ required: true }}
                  name="summary"
                  render={({ onChange, value }) => (
                    <>
                      <label>Summary of Enquiry *</label>
                      <MarkdownEditor
                        onChange={onChange}
                        value={value}
                        dataTest="summary-field"
                      />
                    </>
                  )}
                />
                {errors.summary?.type === "required" && (
                  <Error data-test="summary-validation">
                    This field is required
                  </Error>
                )}
                {/* {errors.summaryOfEnquiry?.type === "maxLength" && (
          <Error data-test="summary-length-validation">Max length exceeded</Error>
        )} */}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button
              onClick={handleSubmit((data: PeRequiredItem) => onSubmit(data))}
              color="primary"
              data-test="confirm-transfer-button"
            >
              Confirm
            </Button>
          </DialogActions>
        </form>
      </>
    </>
  );
};
